<template>
    <v-menu offset-y v-if="inspection">
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind = "attrs"
                v-on   = "on"
                class  = "audit-menu"
            >
                <v-icon color="white" size="24">mdi-menu</v-icon>
            </a>
        </template>

        <div class="white">
            <v-list class="white">
                <v-list-item
                    v-for = "(entry, index) in menu"
                    :key  = "index"
                    link
                >
                    <v-list-item-title
                        @click = "onMenu(entry)"
                        class  = "v-flex"
                    >
                        <div style="margin-top: -2px; margin-right: 8px;">
                            <v-icon
                                size   = "18"
                                :color = "entry.available ? 'black' : 'secondary'"
                            >
                                {{ entry.icon }}
                            </v-icon>
                        </div>

                        <div
                            class  = "menu-name"
                            :class = "entry.available ? 'black--text' : 'secondary--text'"
                        >
                            {{ entry.name }}
                        </div>

                        <div
                            v-if   = "!isImage (entry) && entry.available"
                            class  = "menu-status"
                        >
                            <v-icon size="24" :color="statusColor (entry.status)">{{ statusIcon (entry.status) }}</v-icon>
                        </div>

                        <div
                            v-if   = "isImage(entry)"
                            :class = "entry.available ? 'black--text' : 'secondary--text'"
                        >
                            {{ (counts[entry.id] || 0) + " Bilder" }}
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </div>
    </v-menu>

</template>

<script>
import Disposition from "@/modules/dis/service/Disposition";
import Img from "@/modules/img/components/service/Img";
import Uploads from "@/modules/img/components/service/Uploads";

export default {
    name: "CInspectionMenu",

    props: {
        inspection: {

        }
    },

    data: () => ({
        menu: null,
        // number of images per area (IMAGES: Fotos and Prüfbuch together), from the media service
        counts: {},
        stopFileDone: null,
        timer: null
    }),

    computed: {
        areas () {
            return Disposition.inspection.areas;
        }
    },

    mounted() {
        this.initialize();
        this.stopFileDone = Uploads.onFileDone(({ inspectionId }) => {
            if (this.inspection && inspectionId === this.inspection.id) {
                // the inspection's file list may lag a moment behind the finished upload
                this.loadCounts();
                clearTimeout(this.timer);
                this.timer = setTimeout(() => this.loadCounts(), 2000);
            }
        });
    },

    beforeDestroy () {
        clearTimeout(this.timer);
        this.stopFileDone && this.stopFileDone();
    },

    watch: {
        inspection () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.inspection) {
                return;
            }

            this.menu = Disposition.inspection.menu(this, this.inspection);
            this.loadCounts();

            this.menu.unshift({
                id       : "CONTACTS",
                name     : "Kontakte",
                icon     : "mdi-account-multiple",
                status   : null,
                available: true,
                data     : null
            });
        },

        loadCounts () {
            const inspectionId = this.inspection.id;
            Img.inspectionImages(inspectionId).then(images => {
                if (!this.inspection || this.inspection.id !== inspectionId) {
                    return;
                }
                const count = type => (images || []).filter(image => image.imageType === type).length;
                this.counts = { [this.areas.IMAGES]: count("IMAGE") + count("BOOK") };
            }).catch(() => {});
        },

        onMenu(entry) {
            if (!entry.available) {
                return;
            }

            this.$emit("menu", entry);
        },

        isImage (entry) {
            return entry.id === this.areas.IMAGES;
        },

        statusColor (status) {
            switch (status) {
                case "CREATED":
                    return null;
                case "IN_PROCESS":
                    return "grey";
                case "PROCESS_DONE":
                    return "grey";
                case "TRANSFER_DONE":
                    return "success"
                default:
                    return "black";
            }
        },

        statusIcon (status) {
            switch (status) {
                case "CREATED":
                    return null;
                case "IN_PROCESS":
                    return "mdi-pencil-box";
                case "PROCESS_DONE":
                    return "mdi-thumb-up";
                case "TRANSFER_DONE":
                    return "mdi-thumb-up"
                default:
                    return null;
            }
        }
    }
}
</script>

<style scoped>

/* long names wrap instead of being cut off */
.menu-name {
    width: 110px;
    white-space: normal;
    line-height: 1.3;
    padding: 6px 0;
}

::v-deep .v-list-item .v-list-item__title.v-flex {
    white-space: normal;
    align-items: center;
}

.menu-status {
    margin-top: -2px;
}

::v-deep .v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    line-height: 2.2;
}

</style>